/**
 * Prefer `src/modules/multi-currency/ui/format-money.ts` (Phase D) for financial amounts.
 * Pass `currency` explicitly from `Org.baseCurrencyCode` — do not rely on the `"USD"` default.
 * See `src/modules/multi-currency/ui/README.md` § Display contract.
 */
export const formatCurrency = (value: number, fractionDigits = 0, currency = "USD"): string =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(value || 0);

export const formatPercentage = (value: number, fractionDigits = 2): string => `${(value ?? 0).toFixed(fractionDigits)}%`;

export const formatDate = (
  iso: string | null | undefined,
  timeZone = "America/New_York",
  dateStyle: "short" | "medium" | "long" = "medium",
): string => {
  if (!iso) {
    return "";
  }
  const d = new Date(iso);
  try {
    return new Intl.DateTimeFormat("en-US", { dateStyle, timeZone }).format(d);
  } catch {
    return d.toISOString().slice(0, 10);
  }
};

// Tiny stable hash (FNV-1a)
export const stableHash = (obj: unknown): string => {
  const s = typeof obj === "string" ? obj : JSON.stringify(obj);
  let h = 0x811c9dc5;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = (h + ((h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24))) >>> 0;
  }
  return h.toString(16);
};
